import * as Sentry from '@sentry/react';

import { Integrations } from '@sentry/tracing';
import { initOptions } from './common';

const HealthMonitor = {
  init: (product: string): void => {
    Sentry.init({
      ...initOptions(product),
      integrations: [new Integrations.BrowserTracing()],
    });
  },
  logError: (error: Error): void => {
    Sentry.captureException(error);
  },
  testCrash: (): void => {
    // no-op for web
  },
};

export default HealthMonitor;
